<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X5olBw/tc-custom/9781449498665.jpg?1737680567233" alt="This image is the cover for the book Crown Anthology, Lost Poets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crown Anthology, Lost Poets
      </h1>
      <p class="bookDescription body article font2">
        <b>Two hundred poems of hope and empowerment in a time of tumult and darkness, from Instagram’s Lost Poets community. </b><br/><br/><i>Crown Anthology </i>is a new collection of verse from an online subculture of poets, with a foreword by Tyler Knott Gregson, one of the movement’s foremost authors. By celebrating self-love, self-worth, and empowerment, these two hundred poems examine life in a dynamic and transformative poetry compilation that speaks soft words reminding us that every soul is royal. <br/><br/>Featuring a beautifully diverse and inspirational set of voices from around the world, which includes some of today’s most influential modern poets with additional contest winners chosen from 4,500 submissions, <i>Crown Anthology</i> is curated to be a light in the wild dark, illuminating the crown that exists in everyone.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Analog de Lèon, Gabriel Sage
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ccb2463e